import BoxWrapper from 'blocks/BoxWrapper';
import Button from 'blocks/Button';
import StatusText from 'blocks/StatusText';
import RouteDetail from 'components/Flight/RouteDetail';
import RecieptCard from 'components/RecieptCard';
import BaseModal from 'components/modals/BaseModal';
import { FlightTypeInterface } from 'pages/miles/Claim/claim.interface';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentProps } from './flightDetail.interface';
import * as S from './flightDetailModal.styles';

const Content = ({ open, closeModal, flight }: ContentProps) => {
  const { t } = useTranslation();
  if (!flight) return null;

  return (
    <S.FlightDetailModal>
      {flight.rejectReason ? (
        <p
          style={{
            color: '#F85858',
            padding: '10px',
            background: 'rgba(248,88,88,0.39)',
            borderRadius: '10px',
            margin: ' 10px 0px',
          }}
        >
          {t('pages.miles.claim.modals.details.error')} :
          <span style={{ fontSize: '14px', margin: '0px 3px' }}>{flight.rejectReason}</span>
        </p>
      ) : (
        ''
      )}
      <BoxWrapper>
        <RecieptCard
          rows={[
            {
              id: 1,
              name: t('pages.miles.claim.modals.details.activity'),
              content: flight.Transaction?.activity || '-',
            },
            {
              id: 2,
              name: t('pages.miles.claim.modals.details.rewardMiles'),
              content: flight.Transaction?.rewardMilageUsed || '0',
            },
            {
              id: 3,
              name: t('pages.miles.claim.modals.details.tierMiles'),
              content: flight.Transaction?.tierMilageUsed || '0',
            },
            { id: 4, name: t('pages.miles.claim.modals.details.source'), content: flight.source },
          ]}
        />
      </BoxWrapper>
      <S.GrayCard>
        <RouteDetail flight={flight} showPNR />
      </S.GrayCard>
      <S.BtnContainer>
        <StatusText color={flight.status === 'pending' ? 'warn' : flight.status === 'registered' ? 'success' : 'error'}>
          {flight.status}
        </StatusText>

        <S.Btn as={Button} styleType="default" className="fs-xs" onClick={closeModal}>
          {t('pages.miles.claim.modals.details.closeCTA')}
        </S.Btn>
      </S.BtnContainer>
    </S.FlightDetailModal>
  );
};

interface State {
  open: boolean;
  flight: FlightTypeInterface | null;
}

interface Props {
  ref: any;
}

class FlightDetailModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      open: false,
      flight: null,
    };
  }

  openModal = (flight: FlightTypeInterface): void => this.setState({ open: true, flight });

  closeModal = (): void => this.setState({ open: false });

  render() {
    return (
      <S.FlightDetailModalContainer as={BaseModal} open={this.state.open} closeModal={this.closeModal}>
        {this.state.flight ? (
          <Content {...this.props} open={this.state.open} closeModal={this.closeModal} flight={this.state.flight} />
        ) : null}
      </S.FlightDetailModalContainer>
    );
  }
}

export default FlightDetailModal;
